import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=201464e9&scoped=true&"
import script from "./Good.vue?vue&type=script&lang=js&"
export * from "./Good.vue?vue&type=script&lang=js&"
import style0 from "./Good.vue?vue&type=style&index=0&id=201464e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201464e9",
  null
  
)

export default component.exports